export default {
    title: 'Prijava',
    subtitle: 'Nemate nalog?',
    sign_up: 'Registracija',
    resend: 'Ponovo pošalji verifikacioni email',
    messages: {
        success: 'Email uspešno verifikovan!',
        error: 'Vaša sesija je istekla!',
        invalid: 'Pogrešan email ili lozinka!',
        unverified: 'Nije Vam stigao email?',
        invited: 'Poziv uspešno prihvaćen!',
        user_already_part_of_the_company: 'Već ste deo kompanije',
        token_invalid: 'Zahtev nije validan',
        verification_email_sent: 'Verifikacioni email poslat',
        user_is_not_part_of_the_company: 'Niste deo ove kompanije',
        invitation_unkown_or_used: 'Pozivnica je već iskorišćena ili nevažeća',
        email_already_verified: 'Email je već verifikovan!',
    },
    activating: 'Aktiviranje naloga...',
}
